import React from "react";
import { SuccessHeader } from "../components/SuccessHeader";
import { EmailForm } from "../components/EmailForm";
export default function MobileWebpage() {
  return (
    <div className="bg-black md:flex justify-center items-center">
      <div className="bg-black md:w-[520px] py-10 px-5">
        <SuccessHeader />
        <EmailForm />
      </div>
    </div>
  );
}
